export const NAME = 'account';


/** WEBPACK FOOTER **
 ** ./src/modules/customer/constants.js
 **/